import { OfferState } from 'apis/wolt-capital/types';

import { useGetOfferByMerchantID } from './useGetOfferByMerchantID';

export const useIsWoltCapitalEnabled = (merchantId: string, enabled = true) => {
  const { merchantsOffer, isWoltCapitaFeatureFlagEnabled } = useGetOfferByMerchantID(merchantId, enabled);
  const hasOfferURL = merchantsOffer?.url || merchantsOffer?.state !== OfferState.NOT_AVAILABLE;

  return isWoltCapitaFeatureFlagEnabled && !!hasOfferURL && merchantsOffer;
};
